import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { EnumSiaqs } from 'src/app/entity/enum/enum-siaqs';
import { FormCd001Classificacao } from 'src/app/entity/forms/form-cd001-classificacao';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';

import { SiaqsService } from './../../../services/siaqs.service';
import { Cd001CardClassificacaoIComponent } from './partialViews/cd001-card-classificacao-I.component';
import { Cd001CardClassificacaoIIComponent } from './partialViews/cd001-card-classificacao-II.component';
import { Cd001CardClassificacaoIIIComponent } from './partialViews/cd001-card-classificacao-III.component';
import { Cd001CardClassificacaoIVComponent } from './partialViews/cd001-card-classificacao-IV.component';
import { Cd001CardClassificacaoVComponent } from './partialViews/cd001-card-classificacao-V.component';
import { Cd001CardClassificacaoVIComponent } from './partialViews/cd001-card-classificacao-VI.component';

@Component({
  selector: 'app-form-cd001-classificacao',
  templateUrl: './form-cd001-classificacao.component.html',
})
export class FormCd001ClassificacaoComponent implements OnInit, AfterViewInit {
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public areaSelect: string = localStorage.getItem('area-select') || null;
  public formCd001Classificacao: FormCd001Classificacao =
    new FormCd001Classificacao();
  generationValue: number = 0;
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";

  listaLS: string[] = [
    '22C',
    '22M',
    '22L',
    '20C',
    '20M',
    '20L',
    '18C',
    '18M',
    '18L',
    '16C',
    '16M',
    '16L',
    '15C',
    '15M',
    '15L',
  ];

  listaRB: string[] = [
    '22R',
    '22RM',
    '22RL',
    '20R',
    '20RM',
    '20RL',
    '18R',
    '18RM',
    '18RL',
    '16R',
    '16RM',
    '16RL',
    'R3',
    'R3M',
    'R3L',
  ];

  @ViewChild(Cd001CardClassificacaoIComponent, { static: false })
  cd001CardClassificacaoIComponent: Cd001CardClassificacaoIComponent;
  @ViewChild(Cd001CardClassificacaoIIComponent, { static: false })
  cd001CardClassificacaoIIComponent: Cd001CardClassificacaoIIComponent;
  @ViewChild(Cd001CardClassificacaoIIIComponent, { static: false })
  cd001CardClassificacaoIIIComponent: Cd001CardClassificacaoIIIComponent;
  @ViewChild(Cd001CardClassificacaoIVComponent, { static: false })
  cd001CardClassificacaoIVComponent: Cd001CardClassificacaoIVComponent;
  // @ViewChild(Cd001CardClassificacaoBasicIVComponent, { static: false })
  // cd001CardClassificacaoBasicIV: Cd001CardClassificacaoBasicIVComponent;
  @ViewChild(Cd001CardClassificacaoVComponent, { static: false })
  Cd001CardClassificacaoVComponent: Cd001CardClassificacaoVComponent;

  @ViewChild(Cd001CardClassificacaoVIComponent, { static: false })
  Cd001CardClassificacaoVIComponent: Cd001CardClassificacaoVIComponent;

  constructor(
    protected formBuilder: FormBuilder,
    protected generalService: GeneralService,
    protected notificationService: NotificationService,
    protected formularioService: FormularioService,
    protected route: ActivatedRoute,
    protected siaqsService: SiaqsService,
    protected resumeAllFormsService: ResumeAllFormsService,
    public dialog: MatDialog
  ) {
    this.header = new CabecalhoDTO();
    this.formulario =
      this.formCd001Classificacao.createFormClassificacao(formBuilder);
  }
  ngAfterViewInit(): void {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = this.route?.snapshot?.params?.type;
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(
              EnumForm.FormCd001Classificacao,
              EnumFormType.Edit
            );
          } else {
            this.header = this.generalService.createHeader(
              EnumForm.FormCd001Classificacao,
              EnumFormType.Details
            );
          }
          await this.updateForm(data);
        } else {

          this.header.ScreenType = this.generalService.getEnumFormType(
            EnumFormType.New
          );
          await this.getUser();
          this.fillCreatedByFormField();
          this.cd001CardClassificacaoIComponent.formulario
            .get('site')
            .setValue(this.generalService.getLocalStorageDataSite());
        }
      }
    });


  }
  ngOnInit(): void {
    this.header = this.generalService.createHeader(
      EnumForm.FormCd001Classificacao,
      EnumFormType.New
    );
    this.btnCollapse = true;
    this.loadingSubject.next(false);

  }

  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number;
    const isAddFlow = id === 0;
    if ((await this.validFormsToSave()) !== '') {
      return;
    }
    await this.buildFormulario();

    if (!this.formulario.get('created_by'))
      this.formulario.get('created_by').setValue(this.currentUser);

    this.resumeAllFormsService.compareAdd(
      this.valuesInitial,
      this.formulario.getRawValue(),
      isAddFlow,
      'cd001_classificacao'
    );
    // CHAMAR MODAL DE CONFIRMACAO
    this.openConfirmDialog(
      this.resumeAllFormsService.valoresAlterados,
      isAddFlow
    );

    // await this.formularioService.saveForm(id, this.formulario.getRawValue(), 'cd001_classificacao',
    //   await this.getRouter());
  }

  public async openConfirmDialog(
    valoresAlterados: any[],
    isAddFlow
  ): Promise<void> {
    const values: any[] = valoresAlterados;

    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow,
      },
    });
    dialogRef.afterClosed().subscribe((x) => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(
          id,
          this.formulario.getRawValue(),
          'cd001_classificacao',
          this.areaSelect.includes('Básica') ? 'formcd001/Básica/classificacao' : 'formcd001/Comercial/classificacao'
        );
      } else {
        this.resumeAllFormsService.valoresAlterados = [];
      }
    });
  }

  async getForms(): Promise<FormGroup[]> {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.cd001CardClassificacaoIComponent.formulario);
    arrForms.push(this.cd001CardClassificacaoIIComponent.formulario);
    arrForms.push(this.cd001CardClassificacaoIIIComponent.formulario);
    arrForms.push(this.cd001CardClassificacaoIVComponent.formulario);
    arrForms.push(this.Cd001CardClassificacaoVComponent.formulario);
    arrForms.push(this.Cd001CardClassificacaoVIComponent.formulario);
    return await arrForms;
  }
  async validFormsToSave(): Promise<string> {
    return await this.formularioService.validForm(await this.getForms());
  }
  async cleanAll(): Promise<void> {
    if (
      this.header.ScreenType ===
      this.generalService.getEnumFormType(EnumFormType.New)
    ) {
      await this.formularioService.cleanForm(await this.getForms());
      await this.getUser();
      this.cd001CardClassificacaoIComponent.formulario
        .get('site')
        .setValue(this.generalService.getLocalStorageDataSite());
    } else {
      const usuario: string =
        this.cd001CardClassificacaoIVComponent.formulario.get('usuario')?.value;
      await this.formularioService.cleanForm(await this.getForms());
      this.cd001CardClassificacaoIVComponent.formulario
        .get('usuario')
        ?.setValue(usuario);
    }
  }
  async collapseAll(): Promise<void> {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.cd001CardClassificacaoIComponent.collapseCard = this.btnCollapse
      ? false
      : true;
    this.cd001CardClassificacaoIIComponent.collapseCard = this.btnCollapse
      ? false
      : true;
    this.cd001CardClassificacaoIIIComponent.collapseCard = this.btnCollapse
      ? false
      : true;
    this.cd001CardClassificacaoIVComponent.collapseCard = this.btnCollapse
      ? false
      : true;
  }
  public async buildFormulario(): Promise<void> {
    this.formulario = await this.formCd001Classificacao.buildForm(
      this.formulario,
      await this.getForms(),
      this.generalService
    );
    console.log(this.formulario.getRawValue());

  }
  public async updateForm(data?: any): Promise<void> {
    this.formulario.get('id').setValue(data.formulario.id);
    await this.formCd001Classificacao.updateForm(
      data,
      await this.getForms(),
      this.generalService
    );
    let form = await this.getForms();
    this.generationValue = form[0].controls.generation?.value;
    this.Cd001CardClassificacaoVComponent.changeSelect(
      data.formulario.liberacao_especial
    );
    await this.areaSelect.includes('Básica') ? this.requiredCamposRetencao() : null;
  }
  public async makeCalculations(event?: any): Promise<void> {

    await this.areaSelect.includes('Básica') ? this.getResultadoRetencaoBasic() : this.getResultadoRetencao()
    await this.areaSelect.includes('Básica') ? this.calcPeneirasFuroRedondo() : null;

    await this.getSiaqs();
    await this.getCalcV();
    await this.setAvaliacaoPrecisonPlanting();
    await this.setAvaliacaoResultadoRetencao();
    await this.setAnel();
    await this.verifyPeneira();
  }

  private async verifyPeneira(): Promise<void> {
    const tipoPeneira: string = this.cd001CardClassificacaoIComponent.formulario.get('peneira')?.value;
    console.log(tipoPeneira);

    const verificaC1 = tipoPeneira.includes('C1');
    const verificaC2 = tipoPeneira.includes('C2');
    const verificaC3 = tipoPeneira.includes('C3');
    const verificaR1 = tipoPeneira.includes('R1');
    const verificaR2 = tipoPeneira.includes('R2');
    const verificaR3 = tipoPeneira.includes('R3');

    this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezeMeioPrc = false;
    this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezePrc = false;
    this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozeMeioPrc = false;
    this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozePrc = false;
    this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraOnzeMeioPrc = false;



    if (verificaC1) {
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_doze_meio_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_doze_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_onze_meio_prc').setValue(null);



      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezeMeioPrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezePrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozePrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraOnzeMeioPrc = true;


    }

    if (verificaC2) {
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_meio_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_doze_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_onze_meio_prc').setValue(null);


      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozeMeioPrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezePrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozePrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraOnzeMeioPrc = true;


    }

    if (verificaC3) {
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_meio_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_onze_meio_prc').setValue(null);


      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozeMeioPrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozePrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraOnzeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezePrc = true;


    }

    if (verificaR1) {
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_meio_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_doze_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_onze_meio_prc').setValue(null);


      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozeMeioPrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezePrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozePrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraOnzeMeioPrc = true;


    }

    if (verificaR2) {
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_meio_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_onze_meio_prc').setValue(null);

      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozeMeioPrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozePrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezePrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraOnzeMeioPrc = true;


    }

    if (verificaR3) {
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_meio_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_treze_prc').setValue(null);
      this.cd001CardClassificacaoIIComponent.formulario.get('retido_peneira_doze_meio_prc').setValue(null);

      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozePrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraOnzeMeioPrc = false;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraDozeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezeMeioPrc = true;
      this.cd001CardClassificacaoIIComponent.isReadOnlyRetidoPeneiraTrezePrc = true;



    }
  }


  async requiredCamposRetencao(): Promise<void> {
    const processo = this.cd001CardClassificacaoIComponent.formulario.get("processo_basica").value as string;
    const peneira = this.cd001CardClassificacaoIComponent.formulario.get("peneira_basica").value as string;

    if (processo != null && peneira != null) {


      if (processo.toUpperCase() != ("Trieur").toUpperCase() || (peneira.toUpperCase() == "22R" || peneira.toUpperCase() == "22C")) {

        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_dois_prc").setValidators([Validators.required])
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_dois_prc").updateValueAndValidity();


      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_dois_prc").clearValidators()
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_dois_prc").updateValueAndValidity();

      }
      if (processo.toUpperCase() != ("Trieur").toUpperCase() || (peneira.toUpperCase() == "20R" || peneira.toUpperCase() == "20C")) {

        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_prc").setValidators([Validators.required])
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_prc").updateValueAndValidity();
      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_prc").clearValidators()
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_vinte_prc").updateValueAndValidity()
      }
      if (processo.toUpperCase() != ("Trieur").toUpperCase() || (peneira.toUpperCase() == "18R" || peneira.toUpperCase() == "18C")) {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezoito_prc").setValidators([Validators.required])
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezoito_prc").updateValueAndValidity();
      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezoito_prc").clearValidators()
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezoito_prc").updateValueAndValidity()
      }
      if (processo.toUpperCase() != ("Trieur").toUpperCase() || (peneira.toUpperCase() == "16R" || peneira.toUpperCase() == "16C")) {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezesseis_prc").setValidators([Validators.required])
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezesseis_prc").updateValueAndValidity();
      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezesseis_prc").clearValidators()
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_dezesseis_prc").updateValueAndValidity()
      }
      if (processo.toUpperCase() != ("Trieur").toUpperCase() || (peneira.toUpperCase() == "15C")) {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_quinze_prc").setValidators([Validators.required])
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_quinze_prc").updateValueAndValidity();
      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_quinze_prc").clearValidators()
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_quinze_prc").updateValueAndValidity()
      }
      if (processo.toUpperCase() != ("Trieur").toUpperCase() || (peneira.toUpperCase() == "R3")) {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_r3_prc").setValidators([Validators.required])
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_r3_prc").updateValueAndValidity();
      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_r3_prc").clearValidators()
        this.cd001CardClassificacaoIIIComponent.formulario.get("retido_peneira_r3_prc").updateValueAndValidity()
      }
      if (processo.toUpperCase() != ("Trieur").toUpperCase()) {

        this.cd001CardClassificacaoIIIComponent.formulario.get("vazado_peneira_corresp_furo_redondo_prc").setValidators([Validators.required])
        this.cd001CardClassificacaoIIIComponent.formulario.get("vazado_peneira_corresp_furo_redondo_prc").updateValueAndValidity();
      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get("vazado_peneira_corresp_furo_redondo_prc").clearValidators()
        this.cd001CardClassificacaoIIIComponent.formulario.get("vazado_peneira_corresp_furo_redondo_prc").updateValueAndValidity()
      }
    }

  }
  private async getSiaqs(): Promise<void> {

    const hibrido = this.cd001CardClassificacaoIComponent.formulario.get('hibrido')?.value as string;

    const peneira = this.areaSelect.includes('Básica') ? this.cd001CardClassificacaoIComponent.formulario.get(
      'peneira_basica'
    )?.value as string : this.cd001CardClassificacaoIComponent.formulario.get(
      'peneira'
    )?.value as string;

    const range =
      (this.cd001CardClassificacaoIVComponent.formulario.get('range_siaqs_mm')
        ?.value as number) ?? 0;

    const desvioPadrao =
      (this.cd001CardClassificacaoIVComponent.formulario.get(
        'desvio_padrao_siaqs_mm'
      )?.value as number) ?? 0;
    const resultadoSiaqs: string = await this.siaqsService.getSiaqs(
      hibrido,
      peneira,
      range,
      desvioPadrao,
      EnumSiaqs.Resultado_Siaqs
    );
    this.cd001CardClassificacaoIVComponent.formulario
      .get('resultado_siaqs')
      .setValue(resultadoSiaqs);

    const resultadoMtvReprSiaqs: string = await this.siaqsService.getSiaqs(
      hibrido,
      peneira,
      range,
      desvioPadrao,
      EnumSiaqs.Motivo_Reprovacao_Siaqs
    );
    this.cd001CardClassificacaoIVComponent.formulario
      .get('motivo_reprovacao_siaqs')
      .setValue(resultadoMtvReprSiaqs);
  }
  private async setAvaliacaoPrecisonPlanting() {
    const prcsingApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'resultado_precision_planting'
    )?.value as string;
    this.Cd001CardClassificacaoVIComponent.formulario
      .get('avaliacao_precision_planting')
      ?.setValue(prcsingApollo);
  }
  private async setAvaliacaoResultadoRetencao() {
    const prcsingApollo =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'resultado_retencao'
      )?.value as string;
    this.Cd001CardClassificacaoVIComponent.formulario
      .get('avaliacao_retencao')
      ?.setValue(prcsingApollo);
  }
  private async setAnel() {
    let resultadoPeneira =
      this.areaSelect.includes('Básica') ? this.cd001CardClassificacaoIComponent.formulario.get(
        'peneira_basica'
      )?.value as string : this.cd001CardClassificacaoIComponent.formulario.get(
        'peneira'
      )?.value as string;

    if (resultadoPeneira === 'SC') {
      this.cd001CardClassificacaoIVComponent.formulario
        .get('anel')
        .setValue('');
      return;
    }

    if (this.listaLS.includes(resultadoPeneira)) {
      this.cd001CardClassificacaoIVComponent.formulario
        .get('anel')
        .setValue('LS');
      return;
    }

    if (this.listaRB.includes(resultadoPeneira)) {
      this.cd001CardClassificacaoIVComponent.formulario
        .get('anel')
        .setValue('RB');
    }
  }
  verifyValueOver100() {
    const vazadoPeneiraCorrespFuroRedondoPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'vazado_peneira_corresp_furo_redondo_prc'
      )?.value as number;

    const vazadoPeneiraCorrespOblongoPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'vazado_peneira_corresp_oblongo_prc'
      )?.value as number;

    const retidoPeneiraTrezeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_treze_meio_prc'
      )?.value as number;

    const retidoPeneiraTrezePrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_treze_prc'
      )?.value as number;

    const retidoPeneiraDozeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_doze_meio_prc'
      )?.value as number;
    const retidoPeneiraDozePrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_doze_prc'
      )?.value as number;
    const retidoPeneira_Onze_Meio_Prc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_onze_meio_prc'
      )?.value as number;

    const retidoPeneiraVinteDoisPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_dois_prc'
      )?.value as number;

    const retidoPeneiraVinteUmPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_um_prc'
      )?.value as number;

    const retidoPeneiraVintePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_prc'
      )?.value as number;

    const retidoPeneiraDezenovePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezenove_prc'
      )?.value as number;

    const retidoPeneiraDezoitoPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezoito_prc'
      )?.value as number;

    const retidoPeneiraDezessetePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezessete_prc'
      )?.value as number;

    const retidoPeneiraDezesseisPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezesseis_prc'
      )?.value as number;

    const retidoPeneiraQuinzePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_quinze_prc'
      )?.value as number;
    const retidoPeneiraR3Prc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_r3_prc'
      )?.value as number;
    if (vazadoPeneiraCorrespFuroRedondoPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Vazado Peneira Corresp Furo Redondo acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('vazado_peneira_corresp_furo_redondo_prc').setErrors({ invalidPeneira: true });
    } else if (vazadoPeneiraCorrespOblongoPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Vazado Peneira Corresp Oblongo  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('vazado_peneira_corresp_oblongo_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraTrezeMeioPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 13,5 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_treze_meio_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraTrezePrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 13 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_treze_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraDozeMeioPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 12,5 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_doze_meio_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraDozePrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 12 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_doze_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneira_Onze_Meio_Prc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 11,5 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_onze_meio_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraVinteDoisPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 22 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_vinte_dois_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraVinteUmPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 21 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_vinte_um_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraVintePrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 20 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_vinte_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraDezenovePrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 19 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_dezenove_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraDezoitoPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 18 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_dezoito_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraDezessetePrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 17 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_dezessete_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraDezesseisPrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 16 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_dezesseis_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraQuinzePrc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira 15 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_quinze_prc').setErrors({ invalidPeneira: true });
    } else if (retidoPeneiraR3Prc > 100) {
      this.notificationService.showNotification(
        `Verficar valor informado no campo Retido Peneira R3 %  acima de 100%.`
      );
      this.cd001CardClassificacaoIIIComponent.formulario.get('retido_peneira_r3_prc').setErrors({ invalidPeneira: true });
    }
  }
  private async getResultadoRetencao(): Promise<void> {
    let section_one: string;
    let section_two: string;


    const vazadoPeneiraCorrespFuroRedondoPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'vazado_peneira_corresp_furo_redondo_prc'
      )?.value as number;

    const vazadoPeneiraCorrespOblongoPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'vazado_peneira_corresp_oblongo_prc'
      )?.value as number;
    const peneira = this.cd001CardClassificacaoIComponent.formulario.get(
      'peneira'
    )?.value as string;

    const retidoPeneiraTrezeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_treze_meio_prc'
      )?.value as number;

    const retidoPeneiraTrezePrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_treze_prc'
      )?.value as number;

    const retidoPeneiraDozeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_doze_meio_prc'
      )?.value as number;
    const retidoPeneiraDozePrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_doze_prc'
      )?.value as number;

    const retidoPeneiraOnzeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_onze_meio_prc'
      )?.value as number;

    const retidoPeneiraVinteDoisPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_dois_prc'
      )?.value as number;

    const retidoPeneiraVinteUmPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_um_prc'
      )?.value as number;

    const retidoPeneiraVintePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_prc'
      )?.value as number;

    const retidoPeneiraDezenovePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezenove_prc'
      )?.value as number;

    const retidoPeneiraDezoitoPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezoito_prc'
      )?.value as number;

    this.verifyValueOver100();
    let resultadoRetencao: string = '';
    if (vazadoPeneiraCorrespFuroRedondoPrc > 4) {
      section_two = 'Reprovado';
    }
    else if (
      !!peneira &&
      peneira?.substr(0, 1) === 'R' &&
      vazadoPeneiraCorrespOblongoPrc > 7
    ) {
      section_one = 'Reprovado';
    }

    if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraOnzeMeioPrc != null
    ) {

      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C1' && retidoPeneiraDozeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C1' && retidoPeneiraDozePrc !== null) {
      resultadoRetencao = 'Reprovado';

    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'C2' && retidoPeneiraTrezeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C2' && retidoPeneiraOnzeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C2' && retidoPeneiraDozePrc !== null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C3' && retidoPeneiraTrezeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C3' && retidoPeneiraOnzeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C3' && retidoPeneiraTrezePrc !== null) {
      resultadoRetencao = 'Reprovado';

    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'R1' && retidoPeneiraTrezeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'R1' && retidoPeneiraDozePrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'R1' && retidoPeneiraOnzeMeioPrc !== null) {
      resultadoRetencao = 'Reprovado';

    }
    else if (!peneira &&
      peneira?.substr(0, 2) === 'R2' && retidoPeneiraTrezeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!peneira &&
      peneira?.substr(0, 2) === 'R2' && retidoPeneiraTrezePrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!peneira &&
      peneira?.substr(0, 2) === 'R2' && retidoPeneiraOnzeMeioPrc !== null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'R3' && retidoPeneiraTrezeMeioPrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'R3' && retidoPeneiraTrezePrc != null) {
      resultadoRetencao = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'R3' && retidoPeneiraDozeMeioPrc !== null) {
      resultadoRetencao = 'Reprovado';


    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      (retidoPeneiraVinteUmPrc > 15)
    ) {
      section_two = 'Reprovado';


    }

    if (!!peneira &&
      peneira?.substr(0, 2) === 'C1' && retidoPeneiraTrezePrc > 7 && retidoPeneiraTrezeMeioPrc == 0) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C1' && retidoPeneiraTrezePrc > 7 && retidoPeneiraTrezeMeioPrc == null) {
      section_one = 'Reprovado';
    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C1' && retidoPeneiraTrezePrc > 7 && retidoPeneiraTrezeMeioPrc > 0) {
      section_one = 'Reprovado';

    } if (!!peneira &&
      peneira?.substr(0, 2) === 'C1' && retidoPeneiraTrezePrc <= 7 && retidoPeneiraTrezePrc != null) {
      section_one = 'Aprovado';

    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'C2' && retidoPeneiraDozeMeioPrc > 7 && retidoPeneiraTrezePrc == 0) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C2' && retidoPeneiraDozeMeioPrc > 7 && retidoPeneiraTrezePrc == null) {
      section_one = 'Reprovado';

    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'C2' && retidoPeneiraDozeMeioPrc > 7 && retidoPeneiraTrezePrc > 0) {
      section_one = 'Reprovado';

    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'C2' && retidoPeneiraDozeMeioPrc <= 7 && retidoPeneiraDozeMeioPrc != null) {
      section_one = 'Aprovado';

    } if (!!peneira &&
      peneira?.substr(0, 2) === 'C3' && retidoPeneiraDozePrc > 7 && retidoPeneiraDozeMeioPrc == 0) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C3' && retidoPeneiraDozePrc > 7 && retidoPeneiraDozeMeioPrc == null) {
      section_one = 'Reprovado';

    } else if (!!peneira &&
      peneira?.substr(0, 2) === 'C3' && retidoPeneiraDozePrc > 7 && retidoPeneiraDozeMeioPrc > 0) {
      section_one = 'Reprovado';

    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'C3' && retidoPeneiraDozePrc <= 7 && retidoPeneiraDozePrc != null) {
      section_one = 'Aprovado';

    }

    else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      (
        retidoPeneiraVinteUmPrc > 0 ||
        retidoPeneiraDezenovePrc > 20 ||
        retidoPeneiraDezoitoPrc > 20)
    ) {
      section_two = 'Reprovado';


    }


    if (!!peneira &&
      peneira?.substr(0, 2) === 'R1') {
      if (vazadoPeneiraCorrespOblongoPrc > 7 && retidoPeneiraTrezePrc < 93 && retidoPeneiraDozeMeioPrc == 100) {
        section_one = 'Liberação especial – peneira oblonga';
      } else if (vazadoPeneiraCorrespOblongoPrc > 7 && (retidoPeneiraTrezePrc < 93 && retidoPeneiraDozeMeioPrc == null) || (retidoPeneiraTrezePrc + vazadoPeneiraCorrespOblongoPrc) > 100) {
        section_one = 'Reprovado';
      } else if ((retidoPeneiraTrezePrc < 93 && retidoPeneiraTrezePrc != null && retidoPeneiraDozeMeioPrc < 100 && retidoPeneiraDozeMeioPrc != null) || vazadoPeneiraCorrespOblongoPrc > 7) {
        section_one = 'Reprovado';
      } else if ((vazadoPeneiraCorrespOblongoPrc <= 7 && vazadoPeneiraCorrespOblongoPrc != null) && (retidoPeneiraTrezePrc >= 93 && retidoPeneiraTrezePrc != null)) {
        section_one = 'Aprovado';

      }
      if (vazadoPeneiraCorrespFuroRedondoPrc > 4) {
        section_two = 'Reprovado';
      }
    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'R2') {
      if (vazadoPeneiraCorrespOblongoPrc > 7 && retidoPeneiraDozeMeioPrc < 93 && retidoPeneiraDozePrc == 100) {
        section_one = 'Liberação especial – peneira oblonga';
      } else if (vazadoPeneiraCorrespOblongoPrc > 7 && retidoPeneiraDozeMeioPrc < 93 && retidoPeneiraDozePrc == null) {
        section_one = 'Reprovado';
      } else if (retidoPeneiraDozeMeioPrc < 93 && retidoPeneiraDozeMeioPrc != null && retidoPeneiraDozePrc < 100 && retidoPeneiraDozePrc != null || vazadoPeneiraCorrespOblongoPrc > 7) {
        section_one = 'Reprovado';
      } else if ((vazadoPeneiraCorrespOblongoPrc <= 7 && vazadoPeneiraCorrespOblongoPrc != null) && (retidoPeneiraDozeMeioPrc >= 93 && retidoPeneiraDozeMeioPrc != null)) {
        section_one = 'Aprovado';
      }

      if (vazadoPeneiraCorrespFuroRedondoPrc > 4 || retidoPeneiraVinteUmPrc > 15) {
        section_two = 'Reprovado';
      }

    }
    else if (!!peneira &&
      peneira?.substr(0, 2) === 'R3') {
      if (retidoPeneiraDozePrc > 7 && retidoPeneiraDozePrc < 93 && retidoPeneiraOnzeMeioPrc == 100) {
        section_one = 'Liberação especial – peneira oblonga';
      } else if (vazadoPeneiraCorrespOblongoPrc > 7 && retidoPeneiraDozePrc < 93 && retidoPeneiraOnzeMeioPrc == null) {
        section_one = 'Reprovado';
      } else if (retidoPeneiraDozePrc < 93 && retidoPeneiraDozePrc != null && retidoPeneiraOnzeMeioPrc < 100 && retidoPeneiraOnzeMeioPrc != null || vazadoPeneiraCorrespOblongoPrc > 7) {
        section_one = 'Reprovado';
      } else if ((vazadoPeneiraCorrespOblongoPrc <= 7 && vazadoPeneiraCorrespOblongoPrc != null) && (retidoPeneiraDozePrc >= 93 && retidoPeneiraDozePrc != null)) {
        section_one = 'Aprovado';
      }

      if (vazadoPeneiraCorrespFuroRedondoPrc > 4 || retidoPeneiraVinteUmPrc > 0 || retidoPeneiraDezoitoPrc > 20 || retidoPeneiraDezenovePrc > 20) {
        section_two = 'Reprovado';
      }

    }
    if (section_one == 'Aprovado' && section_two == 'Aprovado') {
      resultadoRetencao = 'Aprovado';

    } else if (section_one == 'Reprovado' && section_two == 'Reprovado') {
      resultadoRetencao = 'Reprovado';

    } else if (section_one == 'Liberação especial – peneira oblonga' && section_two == 'Aprovado') {
      resultadoRetencao = 'Liberação especial – peneira oblonga';
    } else if (section_one == 'Liberação especial – peneira oblonga' && section_two == 'Reprovado') {
      resultadoRetencao = 'Reprovado';

    } else if (section_one == 'Liberação especial – peneira oblonga' && section_two == null) {
      resultadoRetencao = 'Liberação especial – peneira oblonga';
    } else if (section_one == 'Reprovado' && section_two == 'Aprovado') {
      resultadoRetencao = 'Reprovado';

    } else if (section_one == 'Aprovado' && section_two == 'Reprovado') {
      resultadoRetencao = 'Reprovado';

    } else if (section_one == 'Aprovado' && section_two == null) {
      resultadoRetencao = 'Aprovado';

    } else if (section_one == null && section_two == 'Aprovado') {
      resultadoRetencao = 'Aprovado';

    } else if (section_one == 'Reprovado' && section_two == null) {
      resultadoRetencao = 'Reprovado';

    } else if (section_one == '' && section_two == 'Reprovado') {
      resultadoRetencao = 'Reprovado';

    }
    console.log(peneira, resultadoRetencao);

    this.route.paramMap.subscribe((paramMap) => {
      if (paramMap.get('area') !== undefined) {
        if (paramMap.get('area') === eAreaType.basic) {
          if (vazadoPeneiraCorrespFuroRedondoPrc <= 10) {
            resultadoRetencao = 'Aprovado';

          } else {
            resultadoRetencao = 'Reprovado';

          }
        }
        this.cd001CardClassificacaoIIIComponent.formulario
          .get('resultado_retencao')
          .setValue(resultadoRetencao);
      } else {
        this.cd001CardClassificacaoIIIComponent.formulario
          .get('resultado_retencao')
          .setValue(resultadoRetencao);
      }
    });
  }
  private async getResultadoRetencaoBasic(): Promise<void> {
    let section_one: string;
    let section_two: string;


    const vazadoPeneiraCorrespFuroRedondoPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'vazado_peneira_corresp_furo_redondo_prc'
      )?.value as number;

    const vazadoPeneiraCorrespOblongoPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'vazado_peneira_corresp_oblongo_prc'
      )?.value as number;
    const peneira = this.cd001CardClassificacaoIComponent.formulario.get(
      'peneira_basica'
    )?.value as string;

    const retidoPeneiraTrezeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_treze_meio_prc'
      )?.value as number;

    const retidoPeneiraTrezePrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_treze_prc'
      )?.value as number;

    const retidoPeneiraDozeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_doze_meio_prc'
      )?.value as number;
    const retidoPeneiraDozePrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_doze_prc'
      )?.value as number;

    const retidoPeneiraOnzeMeioPrc =
      this.cd001CardClassificacaoIIComponent.formulario.get(
        'retido_peneira_onze_meio_prc'
      )?.value as number;

    const retidoPeneiraVinteDoisPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_dois_prc'
      )?.value as number;

    const retidoPeneiraVinteUmPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_um_prc'
      )?.value as number;
    const retidoPeneiraR3Prc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_r3_prc'
      )?.value as number;

    const retidoPeneiraVintePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_vinte_prc'
      )?.value as number;

    const retidoPeneiraDezenovePrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezenove_prc'
      )?.value as number;

    const retidoPeneiraDezoitoPrc =
      this.cd001CardClassificacaoIIIComponent.formulario.get(
        'retido_peneira_dezoito_prc'
      )?.value as number;

    this.verifyValueOver100();
    let resultadoRetencao: string = '';
    if (vazadoPeneiraCorrespFuroRedondoPrc > 4) {
      section_two = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 1) === 'R' &&
      vazadoPeneiraCorrespOblongoPrc > 4
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      (retidoPeneiraTrezePrc > 15 || retidoPeneiraTrezeMeioPrc > 15)
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      (retidoPeneiraTrezeMeioPrc > 0 ||
        retidoPeneiraTrezePrc > 0 ||
        retidoPeneiraDozeMeioPrc > 20)
    ) {
      section_one = 'Reprovado';

    }

    if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraOnzeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraDozeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraDozePrc !== null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      retidoPeneiraTrezeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      retidoPeneiraOnzeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      retidoPeneiraDozePrc !== null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      retidoPeneiraTrezeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      retidoPeneiraOnzeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      retidoPeneiraTrezePrc !== null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R1' &&
      retidoPeneiraTrezeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R1' &&
      retidoPeneiraDozePrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R1' &&
      retidoPeneiraOnzeMeioPrc !== null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      retidoPeneiraTrezeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      retidoPeneiraTrezePrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      retidoPeneiraOnzeMeioPrc !== null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      retidoPeneiraTrezeMeioPrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      retidoPeneiraTrezePrc != null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      retidoPeneiraDozeMeioPrc !== null
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      (retidoPeneiraVinteUmPrc > 15 ||
        retidoPeneiraVinteDoisPrc > 15 ||
        retidoPeneiraVintePrc > 15)
    ) {
      section_two = 'Reprovado';

    }

    if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraTrezePrc > 10 &&
      retidoPeneiraTrezeMeioPrc == 0
    ) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraTrezePrc > 10 &&
      retidoPeneiraTrezeMeioPrc == null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraTrezePrc > 10 &&
      retidoPeneiraTrezeMeioPrc > 0
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraTrezePrc == 10 &&
      retidoPeneiraTrezeMeioPrc == null
    ) {
      section_one = 'Reprovado';
    }
    if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C1' &&
      retidoPeneiraTrezePrc <= 10 &&
      retidoPeneiraTrezePrc != null
    ) {
      section_one = 'Aprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      retidoPeneiraDozeMeioPrc > 10 &&
      retidoPeneiraTrezePrc == 0
    ) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      retidoPeneiraDozeMeioPrc > 10 &&
      retidoPeneiraTrezePrc == null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      retidoPeneiraDozeMeioPrc > 10 &&
      retidoPeneiraTrezePrc > 0
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C2' &&
      retidoPeneiraDozeMeioPrc <= 10 &&
      retidoPeneiraDozeMeioPrc != null
    ) {
      section_one = 'Aprovado';
    }
    if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      retidoPeneiraDozePrc > 10 &&
      retidoPeneiraDozeMeioPrc == 0
    ) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      retidoPeneiraDozePrc > 10 &&
      retidoPeneiraDozeMeioPrc == null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      retidoPeneiraDozePrc > 10 &&
      retidoPeneiraDozeMeioPrc > 0
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      retidoPeneiraDozePrc <= 10 &&
      retidoPeneiraDozePrc != null
    ) {
      section_one = 'Aprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'C3' &&
      (retidoPeneiraVinteDoisPrc > 0 ||
        retidoPeneiraVinteUmPrc > 0 ||
        retidoPeneiraVintePrc > 0 ||
        retidoPeneiraDezenovePrc > 20 ||
        retidoPeneiraDezoitoPrc > 20)
    ) {
      section_two = 'Reprovado';

    }
    if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R1' &&
      retidoPeneiraTrezePrc < 96 &&
      retidoPeneiraDozeMeioPrc == 100
    ) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R1' &&
      retidoPeneiraTrezePrc < 96 &&
      retidoPeneiraDozeMeioPrc == null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R1' &&
      retidoPeneiraTrezePrc < 96 &&
      retidoPeneiraTrezePrc != null &&
      retidoPeneiraDozeMeioPrc < 100 &&
      retidoPeneiraDozeMeioPrc != null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R1' &&
      retidoPeneiraTrezePrc >= 96 &&
      retidoPeneiraTrezePrc != null
    ) {
      section_one = 'Aprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      retidoPeneiraDozeMeioPrc < 96 &&
      retidoPeneiraDozePrc == 100
    ) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      retidoPeneiraDozeMeioPrc < 96 &&
      retidoPeneiraDozePrc == null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      retidoPeneiraDozeMeioPrc < 96 &&
      retidoPeneiraDozeMeioPrc != null &&
      retidoPeneiraDozePrc < 100 &&
      retidoPeneiraDozePrc != null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R2' &&
      retidoPeneiraDozeMeioPrc >= 96 &&
      retidoPeneiraDozeMeioPrc != null
    ) {
      section_one = 'Aprovado';
    }
    if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      retidoPeneiraDozePrc < 96 &&
      retidoPeneiraDozePrc != null &&
      retidoPeneiraOnzeMeioPrc == 100
    ) {
      section_one = 'Liberação especial – peneira oblonga';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      retidoPeneiraDozePrc < 96 &&
      retidoPeneiraDozePrc != null &&
      retidoPeneiraOnzeMeioPrc == null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      retidoPeneiraDozePrc < 96 &&
      retidoPeneiraDozePrc != null &&
      retidoPeneiraOnzeMeioPrc < 100 &&
      retidoPeneiraOnzeMeioPrc != null
    ) {
      section_one = 'Reprovado';
    } else if (
      !!peneira &&
      peneira?.substr(0, 2) === 'R3' &&
      retidoPeneiraDozePrc >= 96 &&
      retidoPeneiraDozePrc != null
    ) {
      section_one = 'Aprovado';
    }
    if (section_one == 'Aprovado' && section_two == 'Aprovado') {
      resultadoRetencao = 'Aprovado';
    } else if (section_one == 'Reprovado' && section_two == 'Reprovado') {
      resultadoRetencao = 'Reprovado';
    } else if (
      section_one == 'Liberação especial – peneira oblonga' &&
      section_two == 'Aprovado'
    ) {
      resultadoRetencao = 'Liberação especial – peneira oblonga';
    } else if (
      section_one == 'Liberação especial – peneira oblonga' &&
      section_two == 'Reprovado'
    ) {
      resultadoRetencao = 'Reprovado';
    } else if (
      section_one == 'Liberação especial – peneira oblonga' &&
      section_two == null
    ) {
      resultadoRetencao = 'Liberação especial – peneira oblonga';
    } else if (section_one == 'Reprovado' && section_two == 'Aprovado') {
      resultadoRetencao = 'Reprovado';
    } else if (section_one == 'Aprovado' && section_two == 'Reprovado') {
      resultadoRetencao = 'Reprovado';
    } else if (section_one == 'Aprovado' && section_two == null) {
      resultadoRetencao = 'Aprovado';
    } else if (section_one == null && section_two == 'Aprovado') {
      resultadoRetencao = 'Aprovado';
    } else if (section_one == 'Reprovado' && section_two == null) {
      resultadoRetencao = 'Reprovado';
    } else if (section_one == '' && section_two == 'Reprovado') {
      resultadoRetencao = 'Reprovado';
    }
    this.route.paramMap.subscribe((paramMap) => {
      if (paramMap.get('area') !== undefined) {
        if (paramMap.get('area') === eAreaType.basic) {
          if (vazadoPeneiraCorrespFuroRedondoPrc <= 10) {
            resultadoRetencao = 'Aprovado';
          } else {
            resultadoRetencao = 'Reprovado';
          }
        }
        this.cd001CardClassificacaoIIIComponent.formulario
          .get('resultado_retencao')
          .setValue(resultadoRetencao);
      } else {
        this.cd001CardClassificacaoIIIComponent.formulario
          .get('resultado_retencao')
          .setValue(resultadoRetencao);
      }
    });
  }
  private async getUser(): Promise<void> {
    await this.formularioService
      .getUser()
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!this.areaSelect.includes("Básica")) {
          this.cd001CardClassificacaoIVComponent.formulario
            .get('usuario')
            .setValue(response['user-profile']?.displayName ?? 'Administrador');
        }
        else {
          this.Cd001CardClassificacaoVIComponent.formulario
            .get('usuario')
            .setValue(response['user-profile']?.displayName ?? 'Administrador');
        }
        this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
      })
      .catch(async (error) => {
        await this.generalService.getUserNameValue().subscribe((response) => {
          if (!this.areaSelect.includes("Básica")) {
            this.cd001CardClassificacaoIVComponent.formulario
              .get('usuario')
              .setValue(response);
          }
          else {

            this.Cd001CardClassificacaoVIComponent.formulario
              .get('usuario')
              .setValue(response)
          }
          this.currentUser = response;

        })
      });
  }

  private fillCreatedByFormField(): void {
    this.Cd001CardClassificacaoVComponent.formulario.get('criado_por').setValue(this.currentUser);
  }

  getRouter = async (): Promise<string> => {
    let router: string;
    await this.route.paramMap.subscribe((paramMap) => {
      router = `formcd001/${paramMap.get('area')}/classificacao`;
    });
    return router;
  };
  generationChange = (value: number) => {
    this.generationValue = value;
  };
  backList = async () => {
    this.generalService.goToRoute(await this.getRouter());
  };
  calcResultAvaliacao = () => {
    // let isFemea = true;
    // if (
    //   this.cd001CardClassificacaoBasicIV.formulario.controls.generation.value === 1 ||
    //   this.cd001CardClassificacaoBasicIV.formulario.controls.generation.value === 2
    // ) {
    //   if (isFemea) {
    //     if (
    //       this.cd001CardClassificacaoBasicIV.formulario.controls.falha.value <= 2 &&
    //       this.cd001CardClassificacaoBasicIV.formulario.controls.dupla.value <= 3
    //     ) {
    //       this.cd001CardClassificacaoBasicIV.formulario.controls.resultAvaliacao.setValue('APROVADO');
    //     } else {
    //       this.cd001CardClassificacaoBasicIV.formulario.controls.resultAvaliacao.setValue('REPROVADO');
    //     }
    //   } else {
    //   }
    // }
  };

  async getCalcV(): Promise<void> {


    await this.calcSingulcaoApollo();
    if (!this.areaSelect.includes('Básica')) {
      await this.calcSingulcaoSocidisco();
      await this.calcResultadoPrecisonPlanting();
      await this.calcMotivoReprovacaoPrecisionPlanting();
    } else {

      await this.calcResultadoPrecisonPlantingBasica();
      await this.calcMotivoReprovacaoPrecisionPlantingBasica();
      await this.blockCampos();
    }
  }
  blockCampos() {
    const resultado = this.cd001CardClassificacaoIIIComponent.formulario
      .get('resultado_retencao').value as string
    console.log(resultado);

    if (resultado.toUpperCase() == ("Reprovado").toUpperCase()) {
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'prc_dupla_apollo'
      ).disable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'prc_falha_apollo'
      ).disable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'grafite'
      ).disable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'disco_apollo'
      ).disable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'anel_apollo'
      ).disable()
      this.Cd001CardClassificacaoVComponent.formulario
        .get('prc_singulacao_apollo')
        .disable();
      this.Cd001CardClassificacaoVComponent.formulario
        .get('motivo_reprovacao_precision_planting')
        .setValue(null);
      this.Cd001CardClassificacaoVComponent.formulario
        .get('resultado_precision_planting')
        .setValue(null);
      this.Cd001CardClassificacaoVComponent.formulario
        .get('prc_singulacao_apollo')
        .setValue(null);
    }
    else {
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'prc_dupla_apollo'
      ).enable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'prc_falha_apollo'
      ).enable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'grafite'
      ).enable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'disco_apollo'
      ).enable()
      this.Cd001CardClassificacaoVComponent.formulario.get(
        'anel_apollo'
      ).enable()
    }
  }
  calcSingulcaoApollo() {
    var calc = 100;
    const duplaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_apollo'
    )?.value as number;
    const falhaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_apollo'
    )?.value as number;
    calc = calc - duplaApollo - falhaApollo;
    this.Cd001CardClassificacaoVComponent.formulario
      .get('prc_singulacao_apollo')
      .setValue(calc);
  }
  calcSingulcaoSocidisco() {
    var calc = 100;
    const duplaSocidisco = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_socidisco'
    )?.value as number;
    const falhaSocidisco = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_socidisco'
    )?.value as number;
    calc = calc - duplaSocidisco - falhaSocidisco;
    this.Cd001CardClassificacaoVComponent.formulario
      .get('prc_singulacao_socidisco')
      ?.setValue(calc);
  }
  calcResultadoPrecisonPlanting() {
    let resultado_siaqs: string = 'APR';
    const duplaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_apollo'
    )?.value as number;
    const falhaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_apollo'
    )?.value as number;
    const duplaSocidisco = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_socidisco'
    )?.value as number;
    const falhaSocidisco = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_socidisco'
    )?.value as number;
    if (
      falhaSocidisco <= 1.5 &&
      falhaApollo <= 1.5 &&
      duplaApollo <= 2.5 &&
      duplaSocidisco <= 2.5
    ) {
      this.Cd001CardClassificacaoVComponent.formulario
        .get('resultado_precision_planting')
        .setValue('APROVADO');
      resultado_siaqs = 'APR';
    } else {
      this.Cd001CardClassificacaoVComponent.formulario
        .get('resultado_precision_planting')
        .setValue('REPROVADO');
      resultado_siaqs = 'REP';
    }
  }
  calcMotivoReprovacaoPrecisionPlanting() {
    const duplaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_apollo'
    )?.value as number;
    const falhaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_apollo'
    )?.value as number;
    const duplaSocidisco = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_socidisco'
    )?.value as number;
    const falhaSocidisco = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_socidisco'
    )?.value as number;
    var jsonPrecision = {
      duplaApollo,
      duplaSocidisco,
      falhaApollo,
      falhaSocidisco,
    };
    var reporvados = {
      falhaApollo: 'FALHA APOLLO',
      falhaSocidisco: 'FALHA SOCIDISCO',
      duplaSocidisco: 'DUPLA SOCIDISCO',
      duplaApollo: 'DUPLA APOLLO',
    };
    var motivo = 'REPROVADO EM ';
    var hasMotivo = false;

    Object.keys(jsonPrecision).forEach(function (key) {
      if ((jsonPrecision[key] > 1.5 && (key == 'falhaApollo' || key == 'falhaSocidisco')) || (jsonPrecision[key] > 2.5 && (key == 'duplaApollo' || key == 'duplaSocidisco'))) {
        motivo += reporvados[key] + '; ';
        hasMotivo = true;
      }
    });
    if (hasMotivo) {
      this.Cd001CardClassificacaoVComponent.formulario
        .get('motivo_reprovacao_precision_planting')
        .setValue(motivo);
    }
    else {
      this.Cd001CardClassificacaoVComponent.formulario
        .get('motivo_reprovacao_precision_planting')
        .setValue("");
    }
  }
  calcResultadoPrecisonPlantingBasica() {
    let resultado_siaqs: string = 'APR';
    const duplaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_apollo'
    )?.value as number;
    const falhaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_apollo'
    )?.value as number;
    const geracao = this.cd001CardClassificacaoIComponent.formulario.get(
      'geracao'
    )?.value as string;
    const class1 = this.cd001CardClassificacaoIComponent.formulario.get(
      'classe'
    )?.value as string;
    if (class1 != null) {
      if (geracao == 'G2' || geracao == 'G3') {
        if (class1.toUpperCase() == ('fêmea').toUpperCase()) {
          if (falhaApollo <= 2 && duplaApollo <= 3) {
            this.Cd001CardClassificacaoVComponent.formulario
              .get('resultado_precision_planting')
              .setValue('APROVADO');
            resultado_siaqs = 'APR';
          } else {
            this.Cd001CardClassificacaoVComponent.formulario
              .get('resultado_precision_planting')
              .setValue('REPROVADO');
            resultado_siaqs = 'REP';
          }
        } else {
          if (falhaApollo <= 1.5 && duplaApollo <= 2.5) {
            this.Cd001CardClassificacaoVComponent.formulario
              .get('resultado_precision_planting')
              .setValue('APROVADO');
            resultado_siaqs = 'APR';
          } else {
            this.Cd001CardClassificacaoVComponent.formulario
              .get('resultado_precision_planting')
              .setValue('REPROVADO');
            resultado_siaqs = 'REP';
          }
        }
      } else if (geracao == 'G1') {
        this.Cd001CardClassificacaoVComponent.formulario
          .get('resultado_precision_planting')
          .setValue('APROVADO');
        resultado_siaqs = 'APR';
      } else {
        if (falhaApollo <= 1.5 && duplaApollo <= 2.5) {
          this.Cd001CardClassificacaoVComponent.formulario
            .get('resultado_precision_planting')
            .setValue('APROVADO');
          resultado_siaqs = 'APR';
        } else {
          this.Cd001CardClassificacaoVComponent.formulario
            .get('resultado_precision_planting')
            .setValue('REPROVADO');
          resultado_siaqs = 'REP';
        }
      }
    }

  }
  calcMotivoReprovacaoPrecisionPlantingBasica() {
    const duplaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_dupla_apollo'
    )?.value as number;
    const falhaApollo = this.Cd001CardClassificacaoVComponent.formulario.get(
      'prc_falha_apollo'
    )?.value as number;
    var jsonPrecision = { duplaApollo, falhaApollo };
    var reporvados = {
      falhaApollo: 'FALHA APOLLO',
      duplaApollo: 'DUPLA APOLLO',
    };
    var motivo = 'REPROVADO EM ';
    var hasMotivo = false;
    const geracao = this.cd001CardClassificacaoIComponent.formulario.get(
      'geracao'
    )?.value as string;
    const class1 = this.cd001CardClassificacaoIComponent.formulario.get(
      'classe'
    )?.value as string;

    Object.keys(jsonPrecision).forEach(function (key) {
      if (class1 != null) {
        if (geracao == 'G2' || geracao == 'G3') {
          console.log(geracao, class1);

          if (class1.toUpperCase() == ('fêmea').toUpperCase()) {
            if ((jsonPrecision[key] > 3 && key == 'duplaApollo') || (jsonPrecision[key] > 2 && key == 'falhaApollo')) {
              motivo += reporvados[key] + '; ';
              hasMotivo = true;
            }
          } else {
            if ((jsonPrecision[key] > 2.5 && key == 'duplaApollo') || (jsonPrecision[key] > 1.5 && key == 'falhaApollo')) {
              motivo += reporvados[key] + '; ';
              hasMotivo = true;
            }
          }
        } else if (geracao != 'G1') {
          if ((jsonPrecision[key] > 2.5 && key == 'duplaApollo') || (jsonPrecision[key] > 1.5 && key == 'falhaApollo')) {
            motivo += reporvados[key] + '; ';
            hasMotivo = true;
          }
        }
      }

    });
    if (hasMotivo) {
      this.Cd001CardClassificacaoVComponent.formulario
        .get('motivo_reprovacao_precision_planting')
        .setValue(motivo);
    }
    else {
      this.Cd001CardClassificacaoVComponent.formulario
        .get('motivo_reprovacao_precision_planting')
        .setValue("");
    }
  }
  calcPeneirasFuroRedondo() {
    const retidoPeneira22 = this.cd001CardClassificacaoIIIComponent.formulario
      .get('retido_peneira_vinte_dois_prc')?.value as number
    const retidoPeneira20 = this.cd001CardClassificacaoIIIComponent.formulario
      .get('retido_peneira_vinte_prc')?.value as number
    const retidoPeneira16 = this.cd001CardClassificacaoIIIComponent.formulario
      .get('retido_peneira_dezesseis_prc')?.value as number
    const retidoPeneira18 = this.cd001CardClassificacaoIIIComponent.formulario
      .get('retido_peneira_dezoito_prc')?.value as number
    const retidoPeneira15 = this.cd001CardClassificacaoIIIComponent.formulario
      .get('retido_peneira_quinze_prc')?.value as number
    const retidoPeneiraR3 = this.cd001CardClassificacaoIIIComponent.formulario
      .get('retido_peneira_r3_prc')?.value as number

    const vazadoPeneiraCorrespFuroRedondoPrc = this.cd001CardClassificacaoIIIComponent.formulario
      .get('vazado_peneira_corresp_furo_redondo_prc')?.value as number

    let somaRetidoPeneira = [retidoPeneira22, retidoPeneira20, retidoPeneira16, retidoPeneira18, retidoPeneira15, retidoPeneiraR3]

    var soma = somaRetidoPeneira.reduce(function (soma, i) {
      return soma + i;
    });
    let calcVazado = soma + vazadoPeneiraCorrespFuroRedondoPrc
    console.log(calcVazado);
    if (vazadoPeneiraCorrespFuroRedondoPrc != null) {
      if (calcVazado != 100) {
        this.notificationService.showNotification(
          `Retido peneira + Vazado Peneira Corresp Furo Redondo acima de 100%.`
        );
        this.cd001CardClassificacaoIIIComponent.formulario.get('vazado_peneira_corresp_furo_redondo_prc').setErrors({ invalidPeneira: true });
      }
      else {
        this.cd001CardClassificacaoIIIComponent.formulario.get('vazado_peneira_corresp_furo_redondo_prc').setErrors({ invalidPeneira: false });
        this.cd001CardClassificacaoIIIComponent.formulario.get('vazado_peneira_corresp_furo_redondo_prc').updateValueAndValidity();
        this.cd001CardClassificacaoIIIComponent.formulario.get('vazado_peneira_corresp_furo_redondo_prc').markAsTouched();
      }
    }
  }
  async getPC003Data(data?: any) {
    await this.formularioService.getPc003Data(data.contratoJuridico, data.safra, data.numeroCampo).pipe(take(1)).toPromise().then((objPC003: any) => {

      this.cd001CardClassificacaoIComponent.formulario.get('geracao').setValue(objPC003?.data?.geracao);
      this.cd001CardClassificacaoIComponent.formulario.get('hibrido_rnc').setValue(objPC003?.data?.hibrido_rnc);

    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um erro, não foi possivel encontrar o valor de prioridade ou Geração.`);
    });
  }

  async makeRequire(data: any): Promise<void> {
    await this.areaSelect.includes('Básica') ? this.requiredCamposRetencao() : null;
  }

  applyFilter(value: string, originalList: any[], filteredList: any[]): void {
    const searchTerm = value?.toLowerCase() || '';
    if (searchTerm) {
      const filteredResults = originalList.filter(item =>
        item.name?.toLowerCase().includes(searchTerm)
      );
      filteredList.length = 0;
      filteredList.push(...(filteredResults.length > 0 ? filteredResults : originalList));
    } else {
      filteredList.length = 0;
      filteredList.push(...originalList);
    }
  }
}
